module.exports = __webpack_public_path__ + "img/charactors1.d12ddf30.png";